






















import {
  CampaignTableRow,
  CampaignTuple,
  PublishedAdSpace,
  ScreenCluster,
} from '@/app/shared/utilities/static-types';
import { Component, Vue, Prop } from 'vue-property-decorator';
import CampaignsTableView from '@campaigns/shared/components/CampaignsTableView.vue';
import CampaignsListView from './CampaignsListView.vue';
import {
  getCampaignDuration,
  getCampaignStartDate,
  stringifyAdSpacesNames,
  getCampaignCreatedAtMs,
} from '../utils';
import {
  loadScreenClusters,
} from '@/app/shared/actions/ClustersActions';
import { getAdSpacesAction } from '@adminDevices/shared/actions';

@Component({
  components: {
    CampaignsTableView,
    CampaignsListView,
  },
})
export default class Campaigns extends Vue {
  @Prop({ required: true, default: () => ({}) })
  public campaignsTuples!: CampaignTuple[];
  @Prop(Boolean) public showReservedUntil!: boolean;
  @Prop({ default: false }) public loading!: boolean;
  public screenClusters: ScreenCluster[] = [];
  public adSpaces: PublishedAdSpace[] = [];
  public adSpacesMap: Record<ScreenCluster['ID'], PublishedAdSpace> = {};
  public internalLoading: boolean = false;

  public async created() {
    try {
      this.internalLoading = true;
      this.screenClusters = await loadScreenClusters();
      this.adSpaces = (await getAdSpacesAction()).filter((adSpace) => adSpace.SCREEN_CLUSTER_REF) as unknown as PublishedAdSpace[];
      this.adSpacesMap = this.adSpaces.reduce((adSpacesMap, adSpace) => ({
        ...adSpacesMap,
        [adSpace.SCREEN_CLUSTER_REF.id]: adSpace,
      }), {});
    } finally {
      this.internalLoading = false;
    }
  }

  // Combined loading state
  public get isLoading(): boolean {
    return this.loading || this.internalLoading;
  }

  public get appLocale(): string {
    return this.$root.$i18n.locale;
  }

  public get campaignsList(): CampaignTableRow[] {
    return this.campaignsTuples.map(([campaignData, campaignRef]) => {
      const mappedScreenClusters =
        campaignData.SCREEN_CLUSTERS ||
        campaignData.SCREEN_CLUSTERS_IDS.map(
          (id: string) => this.screenClusters.find(({ ID }) => id === ID)!,
        );
      const adSpacesNames = campaignData.SCREEN_CLUSTERS_IDS.map((id) => {
        return this.adSpacesMap[id];
      });
      return {
        ...campaignData,
        REF: campaignRef,
        SCREEN_CLUSTERS: mappedScreenClusters,
        AD_SPACES_NAMES: stringifyAdSpacesNames(adSpacesNames),
        COMPANY_NAME: campaignData.COMPANY_NAME || '-',
        START_DATE: getCampaignStartDate(campaignData).toISOString(),
        DURATION_IN_WEEKS: getCampaignDuration(campaignData),
        createdAt: getCampaignCreatedAtMs(campaignData),
      };
    });
  }
}
